import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  selectSector(event) {
    event.currentTarget.querySelector('input').checked = true

    const container = event.currentTarget.closest('.sectors')

    for (const sector of container.querySelectorAll('li')) {
      sector.classList.remove('bg-amber-200/75')
    }

    event.currentTarget.classList.add('bg-amber-200/75')
  }
}
